import { TYPES } from "../../common/constants";
import * as client from "../../services/client";

const getPropertyBuildingsDone = (payload) => ({
  type: TYPES.GET_PROPERTY_BUILDINGS_DONE,
  payload,
});

export const getPropertyBuildings = (propertyId) => (dispatch) => {
  return client.getPropertyBuildings(propertyId).then((response) => {
    if (response.status || response.ok) {
      response.json().then((responsejson) => {
        let filterBuildings = [];
        for (var i = 0; i < responsejson.length; i++) {
          if (responsejson[i].building !== null) {
            filterBuildings.push(responsejson[i]);
          }
        }
        dispatch(getPropertyBuildingsDone(filterBuildings));
      });
    }
  });
};

export const getBuildingLevels = (buildingId) => (dispatch) => {
  return client.getBuildingLevels(buildingId).then((response) => {
    if (response.status === 200 || response.ok) {
      response.json().then((responsejson) => {
        dispatch(getBuildingLevelsDone(responsejson));
      });
    }
  });
};

const getBuildingLevelsDone = (payload) => ({
  type: TYPES.GET_BUILDING_LEVELS_DONE,
  payload,
});
